<template>
    <div>
        <div class="mt-2 px-2">
            <validation-observer #default="{ invalid }">
                <b-form @submit.prevent>
                    <b-row>
                        <b-col lg="4" md="12">
                            <b-form-group label="انتخاب دسته">
                                <validation-provider #default="{ errors }" name="دسته" rules="required">
                                    <v-select v-model="selectCategories" dir="rtl" :searchable="false"
                                        :options="categoriesData" label="name_Fa" :clearable="false">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="12">
                            <b-form-group label="انتخاب زیردسته">
                                <v-select v-model="subCategoryId" dir="rtl" :searchable="false"
                                    :options="selectCategories.subCategories" :reduce="(value) => value.id"
                                    label="name_Fa">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="12">
                            <b-form-group label="نام">
                                <validation-provider #default="{ errors }" name="نام" rules="required">
                                    <b-form-input v-model="form.Name_Fa" autocomplete="off"></b-form-input>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="12">
                            <b-form-group label="نام انگلیسی">
                                <b-form-input v-model="form.Name_En" autocomplete="off"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="12">
                            <b-form-group label="مبلغ (ریال)">
                                <validation-provider name="مبلغ" #default="{ errors }" rules="required">
                                    <cleave dir="ltr" v-model="form.BasePrice" class="form-control mt-25"
                                        autocomplete="off" :raw="false" :options="amountSeparator" />
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="12">
                            <b-form-group label="تخفیف (درصد)">
                                <cleave dir="ltr" v-model="form.DiscountPercent" class="form-control" autocomplete="off"
                                    :raw="false" :options="amountSeparator" />
                            </b-form-group>
                        </b-col>
                        <b-col lg="12" md="12">
                            <b-form-group label="توضیحات محصول">
                                <b-form-textarea v-model="form.Description" dir="rtl" class="text-primary-middle"
                                    rows="3" no-resize />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col xl="4" lg="12" class="mb-1">
                            <div class="d-flex align-items-center border-secondary rounded py-2 px-1">
                                <div class="mr-1">
                                    <b-form-input type="color" v-model="form.color" class="rounded"
                                        style="width:79px; height:79px; border:none; padding:0;" />
                                </div>
                                <div>
                                    <h5 class="font-weight-bolder">رنگ شناسایی</h5>
                                    <p class="mb-0">
                                        نمایش در صفحهٔ ثبت فاکتور جهت شناسایی سریع‌تر
                                    </p>
                                </div>
                            </div>
                        </b-col>
                        <b-col xl="8" lg="12" class="mb-1">
                            <div class="border-secondary rounded py-2 px-1">
                                <div class="d-flex align-items-center py-25">
                                    <b-form-checkbox v-model="form.isAvailabilityBasedOnDayEnabled"
                                        name="weekly-inventory-schedule" switch>
                                        <div style="font-size: 1rem;" class="font-weight-bolder">برنامه هفتگی موجودی
                                        </div>
                                    </b-form-checkbox>
                                </div>
                                <div class="pl-25">
                                    <b-form-checkbox-group v-model="form.availableOnDaysOfWeek"
                                        :disabled="!form.isAvailabilityBasedOnDayEnabled"
                                        :options="optionsWeeklyInventorySchedule" value-field="id" text-field="name"
                                        disabled-field="notEnabled" class="demo-inline-spacing" />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <div class="border-secondary rounded py-2 px-1">
                        <h5 class="font-weight-bolder">مواد اولیه</h5>
                        <p>
                            ثبت مواد اولیه به محصول در صورتی امکان پذیر است که در بخش انبار، مواد اولیه ایجاد شده باشد.
                        </p>
                        <div v-if="materials.length" class="mb-1">
                            <b-row v-for="(item, index) in form.recipeItems" :key="index" class="pt-1"
                                :class="{ 'border-bottom pb-1': index !== form.recipeItems.length - 1 }">
                                <b-col xl="3" lg="6">
                                    <b-form-group label="ماده اولیه - واحد اندازه‌گیری">
                                        <validation-provider #default="{ errors }" name="ماده اولیه" rules="required">
                                            <v-select v-model="item.rawMaterialId" :searchable="false" dir="rtl"
                                                :options="materials" :reduce="(value) => value.id"
                                                :get-option-label="(option) => option.name + ' - ' + unit_management(option.unit)"
                                                :clearable="false">
                                                <template #option="{ name, unit }">
                                                    <div class="d-flex align-items-center">
                                                        <div>{{ name }}</div>
                                                        <span class="mx-50">-</span>
                                                        <div class="mr-50">{{ unit_management(unit) }}</div>
                                                    </div>
                                                </template>
                                                <template #no-options>
                                                    موردی وجود ندارد
                                                </template>
                                            </v-select>
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>
                                <b-col xl="3" lg="6">
                                    <b-form-group label="انبار مصرفی">
                                        <validation-provider #default="{ errors }" name="انبار مصرفی" rules="required">
                                            <v-select v-model="item.warehouseId" :searchable="false" dir="rtl"
                                                :options="warehouses" :reduce="(value) => value.id" label="name"
                                                :clearable="false">
                                                <template #no-options>
                                                    موردی وجود ندارد
                                                </template>
                                            </v-select>
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>
                                <b-col xl="2" lg="5">
                                    <b-form-group label="مقدار مصرفی">
                                        <validation-provider #default="{ errors }" name="مقدار مصرفی" rules="required">
                                            <b-form-input type="number" v-model="item.consumptionAmount"
                                                autocomplete="off"></b-form-input>
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>
                                <b-col xl="2" lg="5">
                                    <b-form-group label="مقدار ضایعات">
                                        <validation-provider #default="{ errors }" name="مقدار ضایعات" rules="required">
                                            <b-form-input type="number" v-model="item.wasteConsumptionAmount"
                                                autocomplete="off"></b-form-input>
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>
                                <b-col xl="2" lg="2" class="mt-50 pt-0 mt-lg-2 pt-lg-25">
                                    <b-button variant="danger" @click="deleteRecipeItems(item)">
                                        <feather-icon icon="Trash2Icon" size="18" />
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>
                        <b-button variant="info" @click="addRecipeItems" :disabled="!materials.length || invalid">
                            اضافه کردن
                        </b-button>
                    </div>
                    <div class="d-flex justify-content-center mt-2 mt-md-3">
                        <div style="width: 250px;height: 250px;">
                            <div v-if="!data.imagePath" @click="selectFile" :class="{ 'upload-file': !imageBlob }"
                                class="pointer d-flex justify-content-center align-items-center">
                                <input @change.prevent="createFile" ref="fileInput"
                                    accept="image/png, image/jpeg, image/webp" type="file" hidden />
                                <div v-if="!imageBlob">
                                    <feather-icon size="95" icon="UploadCloudIcon" color="#7367f0f0" />
                                    <h5 class="text-primary mb-0">بارگذاری تصویر</h5>
                                </div>
                                <div v-if="imageBlob" class="product-img">
                                    <b-img :src="imageBlob" class="object-fit-cover w-100 h-100"
                                        style="border-radius: 18px;" />
                                </div>
                            </div>
                            <div v-if="data.imagePath"
                                class="position-relative d-flex justify-content-center align-items-center w-100 h-100">
                                <div @click="removeImage"
                                    class="position-absolute pointer bg-primary rounded-circle p-25"
                                    style="left: 4px;top: 4px;">
                                    <feather-icon size="22" icon="XIcon" class="text-white" />
                                </div>
                                <div class="categories-img w-100 h-100">
                                    <b-img :src="BASE_URL_File + data.imagePath" class="object-fit-cover w-100 h-100"
                                        style="border-radius: 18px;" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-md-end justify-content-center mt-2">
                        <b-button type="submit" variant="primary" @click="editproduct" :disabled="invalid || loading"
                            class="px-5 mb-2 d-flex align-items-center">
                            <span>ویرایش</span>
                            <b-spinner class="ml-50" v-if="loading" variant="white" small></b-spinner>
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </div>
    </div>
</template>


<script>
import Cleave from 'vue-cleave-component'
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BFormRadio, BForm, BFormInput, BFormFile, BFormCheckboxGroup, BFormCheckbox, BSpinner, BTable, BAvatar, BImg, BFormGroup, BFormTextarea } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, min, max } from '@validations';
import vSelect from 'vue-select';
import { storeService } from '@core/services';
import Compressor from 'compressorjs';

export default {
    components: {
        Cleave,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormInput,
        BFormFile,
        BSpinner,
        BTable,
        BAvatar,
        BFormRadio,
        BImg,
        ValidationProvider,
        ValidationObserver,
        vSelect,
        BFormGroup,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormTextarea
    },
    props: {
        categoriesData: {
            type: Array,
            default: () => [],
        },
        data: {
            type: Object,
            default: () => { },
        },
        materials: {
            type: Array,
            default: () => [],
        },
        warehouses: {
            type: Array,
            default: () => [],
        },
        categoryId: {
            type: Number,
            default: '',
        }
    },
    computed: {
        unit_management() {
            return (status) => {
                if (status == 1) {
                    return 'گرم'
                }
                if (status == 2) {
                    return 'میلی‌لیتر'
                }
                if (status == 3) {
                    return 'عدد'
                }
            }
        },
    },
    watch: {
        'selectCategories'() {
            if (!this.selectCategories.subCategories.length) {
                this.subCategoryId = null
            }
        },
    },
    data() {
        return {
            optionsWeeklyInventorySchedule: [
                { id: 6, name: 'شنبه' },
                { id: 0, name: 'یکشنبه' },
                { id: 1, name: 'دوشنبه' },
                { id: 2, name: 'سه شنبه' },
                { id: 3, name: 'چهارشنبه' },
                { id: 4, name: 'پنج شنبه' },
                { id: 5, name: 'جمعه' },
            ],
            amountSeparator: {
                numeral: true,
                numeralThousandsGroupStyle: 'thousand',
            },
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            required,
            min,
            max,
            storeId: null,
            file: null,
            loading: false,
            imageBlob: null,
            form: {
                CategoryId: null,
                Name_Fa: null,
                Name_En: null,
                Description: null,
                BasePrice: null,
                DiscountPercent: null,
                NewImage: null,
                RemoveCurrentImage: false,
                availableOnDaysOfWeek: [],
                isAvailabilityBasedOnDayEnabled: false,
                color: null,
                recipeItems: []
            },
            subCategoryId: null,
            selectCategories: {
                id: null,
                name_Fa: null,
                subCategories: []
            }
        }
    },
    methods: {
        deleteRecipeItems(value) {
            this.form.recipeItems = this.form.recipeItems.filter(item => item !== value)
        },
        addRecipeItems() {
            this.form.recipeItems.push({
                rawMaterialId: null,
                consumptionAmount: null,
                warehouseId: null,
                wasteConsumptionAmount: 0,
            })
        },
        selectFile() {
            this.$refs['fileInput'].click();
        },
        createFile(event) {
            if (event.target.files[0].size < 1000000) {
                if (event.target.files[0].type === "image/jpeg") {
                    const file = event.target.files[0];
                    new Compressor(file, {
                        quality: 0.6,
                        success: (result) => {
                            this.form.NewImage = result
                            if (this.form.NewImage) {
                                this.imageBlob = URL.createObjectURL(this.form.NewImage);
                            }
                        },
                    });

                }
                else {
                    this.$notif({ type: 'normal', title: 'فرمت وارد شده باید jpeg یا jpg باشد' });
                }
            }
            else {
                this.$notif({ type: 'normal', title: 'حجم تصویر باید کمتر از 1 مگابایت باشد' });
            }
        },
        removeImage() {
            this.data.imagePath = null
        },
        editproduct() {
            this.form.BasePrice = Number(this.form.BasePrice.replace(/,/g, ''));
            this.form.DiscountPercent ? this.form.DiscountPercent = Number(this.form.DiscountPercent.replace(/,/g, '')) : null
            this.loading = true;
            let formData = new FormData();
            if (!this.data.imagePath && !this.form.NewImage) {
                this.form.RemoveCurrentImage = true
                formData.append("RemoveCurrentImage", this.form.RemoveCurrentImage)
            }
            formData.append("Name_Fa", this.form.Name_Fa)
            this.form.Name_En ? formData.append("Name_En", this.form.Name_En) : null
            this.form.NewImage ? formData.append("NewImage", this.form.NewImage, this.form.NewImage.name) : null
            this.form.Description ? formData.append("Description", this.form.Description) : null
            this.form.color ? formData.append("Color", this.form.color) : null
            formData.append("BasePrice", this.form.BasePrice)
            this.form.DiscountPercent ? formData.append("DiscountPercent", this.form.DiscountPercent) : null
            if (this.subCategoryId || this.subCategoryId == 0) {
                formData.append("CategoryId", this.subCategoryId)
            }
            else {
                formData.append("CategoryId", this.selectCategories.id)
            }
            formData.append("IsAvailabilityBasedOnDayEnabled", this.form.isAvailabilityBasedOnDayEnabled)
            if (this.form.availableOnDaysOfWeek.length) {
                for (let index in this.form.availableOnDaysOfWeek) {
                    formData.append(`AvailableOnDaysOfWeek[${index}]`, this.form.availableOnDaysOfWeek[index]);
                }
            }
            if (this.form.recipeItems.length) {
                for (let index in this.form.recipeItems) {
                    formData.append(`RecipeItems[${index}].rawMaterialId`, this.form.recipeItems[index].rawMaterialId);
                    formData.append(`RecipeItems[${index}].consumptionAmount`, this.form.recipeItems[index].consumptionAmount);
                    formData.append(`RecipeItems[${index}].warehouseId`, this.form.recipeItems[index].warehouseId);
                    formData.append(`RecipeItems[${index}].wasteConsumptionAmount`, this.form.recipeItems[index].wasteConsumptionAmount);
                }
            }
            storeService.editProduct(this.storeId, formData, this.data.id).then(({ data }) => {
                this.$emit('editProduct', this.data.id);
                this.$notif({ type: 'success', title: 'محصول با موفقیت ویرایش شد' });
            })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.data.name_Fa != 'null' ? this.form.Name_Fa = this.data.name_Fa : null
        this.data.name_En != 'null' ? this.form.Name_En = this.data.name_En : null
        this.data.basePrice != 'null' ? this.form.BasePrice = this.data.basePrice : null
        this.data.description != 'null' ? this.form.Description = this.data.description : null
        this.data.isSpecial != 'null' ? this.form.IsSpecial = this.data.isSpecial : null
        this.categoriesData.forEach(item => {
            if (item.id == this.categoryId) {
                this.selectCategories = item
            }
        });
        this.data.parentCategoryId ? this.subCategoryId = this.data.categoryId : this.subCategoryId = null
        this.data.discountPercent != 'null' ? this.form.DiscountPercent = this.data.discountPercent : null
        this.data.color != 'null' ? this.form.color = this.data.color : null
        if (this.data.recipeItems.length) {
            for (let index in this.data.recipeItems) {
                this.form.recipeItems.push({
                    rawMaterialId: this.data.recipeItems[index].rawMaterial.id,
                    consumptionAmount: this.data.recipeItems[index].consumptionAmount,
                    warehouseId: this.data.recipeItems[index].warehouse.id,
                    wasteConsumptionAmount: this.data.recipeItems[index].wasteConsumptionAmount,
                })
            }
        }
        if (this.data.availableOnDaysOfWeek) {
            if (this.data.availableOnDaysOfWeek.length) {
                this.form.availableOnDaysOfWeek = this.data.availableOnDaysOfWeek
            }
        }
        this.form.isAvailabilityBasedOnDayEnabled = this.data.isAvailabilityBasedOnDayEnabled
        this.storeId = localStorage.getItem("storeId")
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.upload-file {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='18' ry='18' stroke='%235E50EE95' stroke-width='4' stroke-dasharray='8%2c 16' stroke-dashoffset='15' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 18px;
    Width: 100%;
    height: 250px;
    margin: 0 0 0 0;
}

.product-img {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 16px;
    width: 250px;
    height: 250px;
}
</style>